import { motion } from "framer-motion";

const chapters = [
    { n: "01", t: "Simple", d: "Enterprise power without enterprise complexity. Clean interfaces your teams actually use." },
    { n: "02", t: "Secure", d: "Bank-grade encryption, cryptographic audit trails and enterprise-ready compliance." },
    { n: "03", t: "Scalable", d: "From a single unit to national deployments — built to grow with your ambition." },
    { n: "04", t: "Integrated", d: "One Colecle account, one ecosystem. Every product speaks the same language." },
    { n: "05", t: "Automated", d: "Reminders, notifications, approvals and reports — running so you don't have to." },
    { n: "06", t: "Insightful", d: "Real-time dashboards turn operational data into executive-level clarity." },
];

export default function WhyColecle() {
    return (
        <section id="why" data-testid="why-colecle" className="bg-[#0B1930] text-white relative overflow-hidden">
            <div className="hero-glow top-0 right-[-20%]" style={{ background: "#E8B923" }} />
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-40 relative">
                <div className="grid lg:grid-cols-12 gap-8 mb-24">
                    <div className="lg:col-span-6">
                        <div className="eyebrow">Manifesto</div>
                        <h2 className="headline text-4xl md:text-5xl lg:text-7xl mt-6 text-white">
                            Business software <br /> <em className="not-italic text-[#E8B923]">without</em> the complexity.
                        </h2>
                    </div>
                    <div className="lg:col-span-5 lg:col-start-8 flex items-end">
                        <p className="text-white/70 text-lg leading-relaxed">
                            Six principles that guide every Colecle product — and every decision we make.
                        </p>
                    </div>
                </div>

                <div className="grid lg:grid-cols-12 gap-x-6 gap-y-16">
                    {chapters.map((c, i) => (
                        <motion.div
                            key={c.n}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: (i % 3) * 0.08 }}
                            className="lg:col-span-4"
                        >
                            <div className="hairline-dash mb-6" />
                            <div className="flex items-start gap-6">
                                <div className="font-serif text-4xl md:text-6xl text-[#E8B923]/90 font-light leading-none">{c.n}</div>
                                <div>
                                    <h3 className="font-serif text-2xl md:text-3xl text-white">{c.t}</h3>
                                    <p className="text-white/60 text-sm mt-3 leading-relaxed max-w-xs">{c.d}</p>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
